/** Resolve a section background and choose readable black or white text. */
export function getCampaignSectionTheme(color?: string) {
  if (!color || !/^#(?:[\da-f]{3}|[\da-f]{6})$/i.test(color)) return undefined;
  const hex =
    color.length === 4
      ? color
          .slice(1)
          .split('')
          .map((c) => c + c)
          .join('')
      : color.slice(1);
  const channels = [0, 2, 4].map((offset) => {
    const value = parseInt(hex.slice(offset, offset + 2), 16) / 255;
    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  });
  const luminance = channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
  return { background: color, foreground: luminance > 0.179 ? '#000000' : '#ffffff' };
}
